import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";
import { STACK_MANAGE_ACCESS_TYPES } from "shared/Stack/access/useCanCreateStack";
import { hasAtLeastOneRequiredAction } from "utils/access";
import { SpacesContext } from "views/Account/SpacesProvider";
import { AccountContext } from "views/AccountWrapper";
import { Space } from "types/generated";

/**
 * Spaces the viewer can create a stack in.
 */
const useNewStackAvailableSpaces = (): Space[] => {
  const { spaces } = useTypedContext(SpacesContext);
  const { viewer } = useTypedContext(AccountContext);

  const availableSpaces = useMemo(() => {
    return spaces?.filter((space) =>
      hasAtLeastOneRequiredAction(STACK_MANAGE_ACCESS_TYPES, viewer, space.id)
    );
  }, [spaces, viewer]);

  return availableSpaces || [];
};

export default useNewStackAvailableSpaces;
